/*
 * @Author: atdow
 * @Date: 2024-01-08 11:31:36
 * @LastEditors: null
 * @LastEditTime: 2025-12-03 16:30:06
 * @Description: file description
 */
import { defineStore } from 'pinia'
import { Permission, Menu, RegionList, CategoryTree, MenuList } from '/@/stores/interface/permission'
import {
  // getUserMenuList,
  getUserPermission,
  getRegionTreePermission,
  getTimePermission,
  getCategoryTreePermission,
  getUpdatePopupStatus
} from '/@/api/permission'
import { kebabCase, camelCase, cloneDeep } from 'lodash-es'
import {
  mockMenuList,
  mockMarketOverviewMenu,
  // mockCategoryAnalysisMenu,
  // mockBrandAnalysisMenu,
  mockCategoryAnalysisDashboardMenu,
  mockBrandAnalysisDashboardMenu,
  mockBrandAnalysisBrandOperationIndicatorCompareMenu,
  mockRegionAnalysisMenu,
  mockAiHelperMenu
} from '/@/api/mockData'
import { listDepthFirstTraversal } from '/@/utils/common'
import { StandardRegionTypeEnum } from '/@/enums/index'

export const usePermission = defineStore('permission', {
  state: (): Permission => {
    return {
      isLoad: false,
      menu: [],
      menuList: [],
      permissions: [],
      regionList: [],
      categoryTree: [],
      categoryPermissionCodes: [],
      sysLastMonth: '', // 数据最新时间
      // 当前时间快捷时间
      lastMonth: '',
      ytdList: [],
      mat3List: [],
      mat6List: [],
      mat12List: [],
      // 对比时间快捷时间
      hbMonth: '',
      tbMonth: '',
      tbYtdList: [],
      tbMat3List: [],
      tbMat6List: [],
      tbMat12List: [],
      // 时间
      monthList: [],
      yearList: [],
      middleQuarter: { begin: '', end: '' },
      quarter: { begin: '', end: '' },
      hbMat3List: [],
      useSpecMenus: [],
      useDownloadExcelMenus: [],
      exportCenterConfig: {
        open: false
      },
      exportCenterAnalysisObjectPermissionCodes: [],
      exportCenterIndicatorsPermissionCodes: [],
      intelligentAssistantConfig: {
        open: false
      },
      shouldAutoShowUpdatePopup: false
    }
  },
  actions: {
    getIsLoad (): boolean {
      return this.isLoad === true
    },
    resetIsLoad () {
      this.isLoad = false
    },
    clearAutoShowUpdatePopup () {
      this.shouldAutoShowUpdatePopup = false
    },
    resolveUserPermissionRes (content: anyObj) {
      const { menuList = [], permissions = [] } = content
      this.updatePermissions(permissions || [])
      this.updateMenu(menuList || [])
    },
    resolveRegionPermissionRes (content: anyObj) {
      this.regionList = content.areaList || []
    },
    resolveRegionTimePermission (content: anyObj) {
      const {
        sysLastMonth,
        // 当前时间快捷时间
        lastMonth,
        ytdList,
        mat3List,
        mat6List,
        mat12List,
        // 对比时间快捷时间
        hbMonth,
        tbMonth,
        tbYtdList,
        tbMat3List,
        tbMat6List,
        tbMat12List,
        // 时间
        monthList,
        yearList,
        middleQuarter,
        quarter,
        hbMat3List
      } = content

      this.sysLastMonth = sysLastMonth || ''
      // 当前时间快捷时间
      this.lastMonth = lastMonth || ''
      this.ytdList = ytdList || []
      this.mat3List = mat3List || []
      this.mat6List = mat6List || []
      this.mat12List = mat12List || []
      // 对比时间快捷时间
      this.hbMonth = hbMonth || ''
      this.tbMonth = tbMonth || ''
      this.tbYtdList = tbYtdList || []
      this.tbMat3List = tbMat3List || []
      this.tbMat6List = tbMat6List || []
      this.tbMat12List = tbMat12List || []
      // 时间
      this.monthList = monthList || []
      this.yearList = yearList || []
      this.middleQuarter = middleQuarter || { begin: '', end: '' }
      this.quarter = quarter || { begin: '', end: '' }
      this.hbMat3List = hbMat3List || []
    },
    resolveCategoryTreePermission (content: anyObj) {
      const list = (content || []) as anyObj[]
      listDepthFirstTraversal(
        list,
        item => {
          if (item.sortType !== 'zdy' && !this.categoryPermissionCodes.includes(item.categoryCode)) {
            item.disabled = true
          } else {
            item.disabled = false
          }
          item.children = item.childList
        },
        'childList'
      )
      const categoryList: anyObj[] = cloneDeep(list)
      listDepthFirstTraversal(categoryList, item => {
        delete item['childList']
      })
      this.categoryTree = categoryList as CategoryTree
    },
    getMockMenuList (): Promise<anyObj> {
      return new Promise(resolve => {
        resolve({
          code: 200,
          content: cloneDeep(mockMenuList)
        })
      })
    },
    formatOtherLibraryMenuList (resMenuList: Array<anyObj>): Array<anyObj> {
      const filterMenusList = resMenuList.filter((item: anyObj) =>
        [ '100000', '200000', '2000001', '300000', '3000001', '3000002', '500000' ].includes(item.menuCode)
      )

      const formatMenuList: Array<anyObj> = []
      if (filterMenusList.find(item => item.menuCode === '100000')) {
        formatMenuList.push(mockMarketOverviewMenu)
      }
      // if (filterMenusList.find(item => item.menuCode === '200000')) {
      //   formatMenuList.push(mockCategoryAnalysisMenu)
      // }
      // NOTE 临时，到时候需要删除
      if (filterMenusList.find(item => item.menuCode === '2000001')) {
        formatMenuList.push(mockCategoryAnalysisDashboardMenu)
      }
      // if (filterMenusList.find(item => item.menuCode === '300000')) {
      //   formatMenuList.push(mockBrandAnalysisMenu)
      // }
      // NOTE 临时，到时候需要删除
      if (filterMenusList.find(item => item.menuCode === '3000001')) {
        formatMenuList.push(mockBrandAnalysisDashboardMenu)
      }
      // NOTE 临时，到时候需要删除
      if (filterMenusList.find(item => item.menuCode === '3000002')) {
        formatMenuList.push(mockBrandAnalysisBrandOperationIndicatorCompareMenu)
      }
      if (filterMenusList.find(item => item.menuCode === '500000')) {
        formatMenuList.push(mockRegionAnalysisMenu)
      }

      if (this.intelligentAssistantConfig?.open) {
        formatMenuList.push(mockAiHelperMenu)
      }

      return formatMenuList
    },
    initPermission (): Promise<null> {
      return new Promise((resolve, reject) => {
        Promise.all([
          this.getMockMenuList(),
          getUserPermission(),
          getRegionTreePermission(),
          getTimePermission(),
          getCategoryTreePermission(),
          getUpdatePopupStatus(),
        ])
          .then(res => {
            const [
              mockMenuListRes,
              userPermissionRes,
              regionPermissionRes,
              timePermissionRes,
              categoryTreeRes,
              popupStatusRes
            ] = res
            // console.log('userPermissionRes:', userPermissionRes)
            if (
              mockMenuListRes.code !== 200 ||
              userPermissionRes.code !== 200 ||
              regionPermissionRes.code !== 200 ||
              timePermissionRes.code !== 200 ||
              categoryTreeRes.code !== 200 ||
              popupStatusRes.code !== 200
            ) {
              reject()
              return
            }
            this.isLoad = true

            // const mockMenuList = mockMenuListRes.content
            const {
              menuList,
              categoryCodeList,
              ggShowCodeList,
              downloadExcelCodeList,
              exportCenterConfig,
              exportCenterObjectConfig,
              intelligentAssistantConfig
            } = userPermissionRes.content || {}

            this.shouldAutoShowUpdatePopup = popupStatusRes?.content === true

            this.useSpecMenus = (ggShowCodeList || []).map((code: string) => Number(code))
            this.useDownloadExcelMenus = (downloadExcelCodeList || []).map((code: string) => Number(code))
            this.exportCenterConfig = exportCenterConfig ? exportCenterConfig : { open: false }
            this.exportCenterAnalysisObjectPermissionCodes = exportCenterObjectConfig?.codeList
              ? exportCenterObjectConfig?.codeList
              : []
            this.exportCenterIndicatorsPermissionCodes = exportCenterObjectConfig?.indicatorCodeList
              ? exportCenterObjectConfig?.indicatorCodeList
              : []
            this.intelligentAssistantConfig = intelligentAssistantConfig ? intelligentAssistantConfig : { open: false }
            this.categoryPermissionCodes = categoryCodeList || []
            this.resolveRegionPermissionRes((regionPermissionRes.content || []) as anyObj)

            this.resolveRegionTimePermission((timePermissionRes.content || []) as anyObj)
            this.resolveCategoryTreePermission((categoryTreeRes.content || []) as anyObj)

            // 品类分析、品牌分析、指标库
            const formatPermissionMenuList = (menuList || [])
              .filter((item: anyObj) => [ '200000', '300000', '400000' ].includes(item.menuCode)) // 过滤无用menu
              .map((item: anyObj) => {
                return {
                  ...item,
                  menuType: 2
                }
              })
            listDepthFirstTraversal(
              formatPermissionMenuList,
              item => {
                item.showType = 1 // 显示菜单
              },
              'child'
            )

            // console.log('formatPermissionMenuList:', [ ...this.formatOtherLibraryMenuList(menuList || []), ...formatPermissionMenuList ])
            const formatMenuList = [
              ...this.formatOtherLibraryMenuList(menuList || []),
              ...formatPermissionMenuList
            ].sort((a, b) => a.sort - b.sort)

            this.resolveUserPermissionRes({
              menuList: formatMenuList,
              permissions: []
            })
            resolve(null)
          })
          .catch(() => {
            reject()
          })
      })
    },
    updatePermissions (permissions: Array<string>) {
      this.permissions = permissions || []
    },
    updateMenu (menuList: Array<anyObj>) {
      const homePage = {
        menuCode: '1023957908498501632',
        parentCode: '0',
        menuName: '首页',
        menuIcon: null,
        url: 'home',
        sort: 1,
        type: 1,
        description: '首页',
        channel: 1,
        perms: '',
        open: null,
        child: [],
        parentName: null,
        packageAddress: 'views/home/index',
        showType: 0,
        menuLevel: 1,
        menuType: 2
      }
      const formatMenuList = [ homePage, ...(menuList || []) ].filter(({ menuType }) => Number(menuType) === 2)

      const typeMap: any = {
        0: 'menu_dir',
        1: 'menu',
        2: 'button',
        3: 'tab'
      }
      const recursion = (list: Array<anyObj>, parentPath = ''): Menu => {
        return list.map(item => {
          const {
            menuCode,
            parentCode,
            menuName,
            menuIcon,
            url,
            packageAddress,
            showType,
            child,
            type = 1,
            perms
          } = item
          const prefixPath = parentPath
          const realPath = prefixPath ? `${prefixPath}/${kebabCase(url)}` : kebabCase(url)
          return {
            id: menuCode,
            pid: parentCode | 0,
            type: typeMap[type] || 'menu',
            title: menuName,
            name: camelCase(realPath),
            path: realPath,
            parent_path: prefixPath,
            perms,
            menu_type: 'tab',
            icon: menuIcon,
            url: '',
            component: packageAddress ? `/src/${packageAddress}.vue` : '',
            keepalive: 0,
            extend: 'none',
            hidden: showType !== 1,
            meta: {
              title: menuName
            },
            children: recursion(child || [], realPath)
          }
        })
      }

      this.menu = recursion(formatMenuList)
      this.menuList = menuList || []
    },
    getPermissions (): Array<string> {
      return this.permissions
    },
    getMenu (): Menu {
      return this.menu
    },
    getMenuList (): MenuList {
      return this.menuList
    },
    getRegionList (): RegionList {
      return this.regionList
    },
    getStandardRegionListByRegionType (regionType: StandardRegionTypeEnum): RegionList {
      return this.regionList.filter(item => item.type === regionType)
    }
  }
})
